import { SEARCH_REQUEST } from "./actionTypes";

export default ({objectType, searchText, searchBy}) => ({
  type: SEARCH_REQUEST,
  payload: {
    objectType,      
    searchText,
    searchBy
  }
});